import { Grid } from '@mui/material';
import { Fragment, useState } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import MargaToleCreateView from '../../../components/front_office/marga_tole/MargaToleCreateView';
import MargaToleListView from '../../../components/front_office/marga_tole/MargaToleListView';

const FrontMargaToleCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.FrontOfficeURL + 'front/marga/tole/create/list/view/');

    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };

  return (
      <Fragment>
          <Grid container spacing={3}>
              <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                  <MargaToleCreateView handleFormSuccess={handleFormSuccess} />
              </Grid>
              <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                  <MargaToleListView handleFormSuccess={handleFormSuccess} setOnURL={setOnURL} data={data} error={error} loading={loading} />
              </Grid>
          </Grid>
      </Fragment>
  )
}

export default FrontMargaToleCreateListView